/* ============================================================================
   ShadowRosterSyncer - loads the live Shadow roster from the Worker once.
   ----------------------------------------------------------------------------
   Roster automation (2026-06): a render-null bridge that calls useShadowRoster()
   so the app fetches GET /api/shadow-roster exactly once near launch and UNIONS
   the worker's never-shrinking Shadow/Purified id list onto the bundled baseline
   floor (via setRuntimeShadowRoster inside the hook).

   Mounted as a sibling of PrioritiesSyncer inside QueryClientProvider — it needs
   no auth (the GET endpoint is public), so it can sit high in the tree and run
   for signed-out users too. Until it resolves, every consumer of SHADOW_DEX_IDS
   / curatedRosterFor runs on the bundled baseline, so it never blocks render.
============================================================================ */
import { useShadowRoster } from "@/hooks/useShadowRoster";

export function ShadowRosterSyncer() {
  useShadowRoster();
  return null;
}
